import {useCallback} from "react";
import {Loader} from "@mantine/core";
import {useTranslation} from "react-i18next";
import IconSearch from "../../../assets/search.svg?react";
import classes from "./form-elements.module.css";

interface DocumentGeneratorInputProps {
    inputProps: {
        id: string;
        onChange: (e: any) => void;
        onKeyDown: (e: any) => void;
        value: string;
    };
    comment: string;
    companySearchEnabled: boolean;
    setDropdownOpen: (val: boolean) => void;
    suggestionList: string[];
    searching?: boolean;
    isDraft: boolean;
    onPromptNewFilling?: () => void;
}

export const DocumentGeneratorInput = ({
    inputProps,
    companySearchEnabled,
    setDropdownOpen,
    suggestionList,
    searching,
    isDraft,
    onPromptNewFilling,
}: DocumentGeneratorInputProps) => {
    const {t} = useTranslation();
    const isDateInput = inputProps.id?.startsWith("Dato");

    const handleFocus = useCallback(
        (e: React.FocusEvent<HTMLInputElement>) => {
            if (isDraft && onPromptNewFilling) {
                e.target.blur();
                onPromptNewFilling();
                return;
            }
            if (companySearchEnabled) {
                setDropdownOpen(true);
            }
            if (isDateInput && suggestionList?.length > 0) {
                setDropdownOpen(true);
            }
        },
        [isDraft, onPromptNewFilling, companySearchEnabled, setDropdownOpen, isDateInput, suggestionList]
    );

    if (companySearchEnabled) {
        return (
            <div className={classes.docgenSearchRow}>
                <IconSearch
                    width={18}
                    height={18}
                    aria-hidden
                    className={classes.docgenInputIcon}
                />
                <input
                    id={inputProps.id}
                    value={inputProps.value}
                    onChange={inputProps.onChange}
                    onKeyDown={inputProps.onKeyDown}
                    onFocus={handleFocus}
                    placeholder={t("Action.GetCompanyInfo")}
                    className={`${classes.docgenInput} ${classes.docgenInputWithIcon}`}
                />
                {searching && <Loader size={16} />}
            </div>
        );
    }

    return (
        <>
            <input
                id={inputProps.id}
                value={inputProps.value}
                onChange={inputProps.onChange}
                onKeyDown={inputProps.onKeyDown}
                onFocus={handleFocus}
                className={classes.docgenInput}
            />
            {searching && <Loader size={16} />}
        </>
    );
};
